if (!window.SwymCallbacks) window.SwymCallbacks = [];
window.SwymCallbacks.push(initSwymUI);

let swat;
let settings;
let sectionId;
let elements;

function initSwymUI(swatInstance) {
  swat = swatInstance;
  const wishlistElement = document.querySelector('.swymcs-custom-wishlist');
  settings = JSON.parse(wishlistElement.dataset.settings);
  sectionId = wishlistElement.dataset.sectionid;

  elements = {
    loader: wishlistElement.querySelector('#swymcs-wishlist-loader'),
    container: wishlistElement.querySelector('#swymcs-wishlist-container'),
    itemsContainer: wishlistElement.querySelector('#swymcs-wishlist-items-container'),
    emptyContainer: wishlistElement.querySelector('#swymcs-empty-wishlist-container'),
  };

  fetchWishlist();
}

function fetchWishlist() {
  showLoader();
  swat.fetchLists({
    callbackFn: (lists) => {
      lists = lists.reverse();
      const selectedList = lists[0];

      const currentListId = swat.swymCustomWishlistSelectedListId || lists[0]?.lid;
      swat.swymCustomWishlistSelectedListId = currentListId;

      const listcontents = selectedList?.listcontents || [];

      renderList(listcontents);
    },
    errorFn: (error) => console.error('Error while fetching all Lists', error),
  });
}

async function renderList(list) {
  elements.itemsContainer.innerHTML = '';
  if (list.length > 0) {
    const wishlistedProducts = await fetchProductData(list);
    wishlistedProducts.forEach(renderWishlistItem);
  }
  updateUIState(list);
}

async function fetchProductData(wishlist) {
  const productDataPromises = wishlist.map(async (listItem) => {
    try {
      const response = await fetch(`${listItem.du.split('?')[0]}.js`);

      if (!response.ok) throw new Error('Product not found');

      listItem.productData = await response.json();
      return listItem;
    } catch (error) {
      console.error(`Failed to fetch product data for URL: ${listItem.du}`, error);
      return null;
    }
  });

  const resolvedProductData = await Promise.all(productDataPromises);

  return resolvedProductData.filter(item => item !== null);
}

function renderWishlistItem(item) {
  const wishlistItem = document.createElement('div');
  wishlistItem.classList.add('c-card', 'card--standard', 'card--media');
  wishlistItem.setAttribute('style', '--ratio-percent: 100%');
  wishlistItem.setAttribute('role', 'group');
  item.du = item.du.split('?')[0];
  wishlistItem.dataset.epi = item.epi;
  wishlistItem.dataset.empi = item.empi;
  wishlistItem.dataset.du = item.du;
  wishlistItem.dataset.sectionid = sectionId;

  const selectedVariant = item.productData.variants.find((variant) => variant.id == item.epi);
  const productImage = selectedVariant?.featured_image?.src || item.productData?.featured_image || item.iu;
  const label = item.dt + ' ' + selectedVariant?.title
  let imageAlt = selectedVariant?.featured_image?.alt || label;
  if (!imageAlt) {
      imageAlt = item.dt + ' ' + selectedVariant?.title
  }
  const isInCart = _swat.platform.isInDeviceCart(selectedVariant.id);

  wishlistItem.setAttribute('aria-label', `product`);
  const getButtonState = () =>
    selectedVariant?.available
      ? isInCart
        ? settings.swym_wishlist_item_cta_addedtocart
        : settings.swym_wishlist_item_cta_addtocart
      : settings.swym_wishlist_item_cta_soldout;

      wishlistItem.innerHTML = `
      <a href="${item.du}?variant=${selectedVariant.id}">
        <div class="c-card__image">
            <img src="${productImage}" class="motion-reduce swymcs-wishlistplus-item-image" alt="${imageAlt}" style="height:auto"/>
        </div>
        <div class="c-card__text">
            ${
                settings.swym_wishlist_show_vendor
                ? `<p class="c-card__brand">${item.productData.vendor}</p>`
                : ''
            }
            <h3 class="c-card__name">${item.dt}</h3>
            <p class="c-card__name c-card__variant">${selectedVariant.title}</p>
            ${
                settings.swym_wishlist_show_price
                  ? `<div class="c-card__price"><span class="c-card__price__number">${_swat.currency}${item.pr}</span></div>`
                  : ''
            }
            <div class="swymcs-wishlist-action-container">
                ${
                    settings.swym_wishlist_show_addtocart
                    ? `<button class="swymcs-wishlist-add-to-cart-button" data-action="add-to-cart" ${
                        !selectedVariant?.available ? 'disabled' : ''
                        }>${getButtonState()}</button>`
                    : ''
                }
            </div>
            ${
                settings.swym_wishlist_show_delete_item
                  ? `<button id="swymcs-remove-productBtn" aria-label="Delete" class="swymcs-wishlistplus-item-remove">
                  <img class="_on" src="https://dev-isseymiyakenolita.myshopify.com/cdn/shop/t/29/assets/exp-favorite_on.svg?v=69789786379954322071721800895" alt="on"></button>`
                  : ''
            }
            ${
              settings.swym_wishlist_show_delete_item
                ? `<button id="swymcs-remove-product-Btn-2" type="button" class="">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.878 122.88" enable-background="new 0 0 122.878 122.88" xml:space="preserve"><g><path d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z"/></g></svg> Remove
                </button>`
                : ''
          }
        </div>
      </a>
    `;

  wishlistItem.querySelector('[data-action="add-to-cart"]')?.addEventListener('click', (event) => {
    event.preventDefault();
    let button = event.target;

    let { empi, epi, du, qty } = item;

    let originalButtonState = button.innerHTML;
    button.innerHTML = settings.swym_wishlist_item_cta_addingtocart;

    swat.replayAddToCart(
      { empi: empi, du: du, qty: qty },
      epi,
      (success) => {
        button.innerHTML = settings.swym_wishlist_item_cta_addedtocart;
        const variant = JSON.parse(success).items[0];
        const productTitle = variant.title;
        let successMessage = `<strong>${productTitle}</strong> has been added to bag!`;
        // swat.ui.showSuccessNotification({ message: successMessage });
      },
      (error) => {
        button.innerHTML = originalButtonState;
        swat.ui.showErrorNotification({ message: error.description });
      }
    );
  });

  wishlistItem.querySelector('#swymcs-remove-productBtn')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    let product = {
      epi: item.epi,
      empi: item.empi,
      du: item.du,
    };
    _swat.deleteFromList(
      _swat.swymCustomWishlistSelectedListId,
      product,
      fetchWishlist,
      (error) => console.error('Failed to remove from wishlist', error)
    );
  });


  wishlistItem.querySelector('#swymcs-remove-product-Btn-2').addEventListener('click', (e) => {
    e.preventDefault();
    wishlistItem.querySelector('#swymcs-remove-productBtn').click();
  })

  elements.itemsContainer.appendChild(wishlistItem);
}

function updateUIState(wishlist) {
  hideLoader();
  if (wishlist.length > 0) {
    elements.container.classList.remove('swymcs-hide-container');
    elements.emptyContainer.classList.add('swymcs-hide-container');
  } else {
    elements.emptyContainer.classList.remove('swymcs-hide-container');
    elements.container.classList.add('swymcs-hide-container');
  }
}

function showLoader() {
  elements.loader.classList.remove('swymcs-hide-container');
}

function hideLoader() {
  elements.loader.classList.add('swymcs-hide-container');
}
